import { TFunction } from 'i18next';
import { ListRowProps } from '../../../../../tools';
import { getSafeString } from './utils';
import { ApplicationResponse, Consultation } from '../../../../../types';

export const getContactDetails = (
  t: TFunction,
  application?: ApplicationResponse,
  consultation?: Consultation
): ListRowProps[] => [
  {
    label: t('agent_name', 'Agent name'),
    value: getSafeString(application?.agentsName),
  },
  {
    label: t('agent_company', 'Agent company'),
    value: getSafeString(application?.agentsCompany),
  },
  {
    label: t('agent_phone_number', 'Agent phone number'),
    value: getSafeString(application?.agentsPhoneNumber),
  },
  {
    label: t('agent_email_address', 'Agent email address'),
    value: getSafeString(application?.agentsEmailAddress),
  },
  {
    label: t('contact_name_case_officer', 'Contact name (Case officer)'),
    value: getSafeString(consultation?.caseOfficerName),
  },
  {
    label: t('telephone_number_case_officer', 'Telephone number (Case officer)'),
    value: getSafeString(consultation?.caseOfficerContactNumber),
  },
];
